import { useState } from "react";
import { getStepStatus, getStepStatusColor } from "../../lib/utils/stencilWeekUtils";



/**
 * This component shows multiple stencil-week rows (like Week 1, 2, 3)
 * It lets the volunteer choose the one they want to work on.
 * 
 * Instead of saying "Week 1", we show Tracing / Carving status +  volunteer names
 */
const Options = ({ stencilWeeks, setStencilWeek, step }) => {
  const [selectedIdx, setSelectedIdx] = useState(null); // track which button was clicked

  const handleSelect = (sw, index) => {
    setSelectedIdx(index); // mark selected index (to highlight it)
    setStencilWeek(sw);     // set the chosen stencil_week for the app
  };

  return (
    <>
      <p className="vol-checktitle"><strong>Select the one you're working on:</strong></p>
      <div className="vol-choice-grid">
        {stencilWeeks.map((sw, idx) => (
          <button
            key={sw.week_num}
            type="button"
            className={`vol-choice ${idx === selectedIdx ? "selected" : ""}`}
            onClick={() => handleSelect(sw, idx)}
          >
            {step === "tracing" && <div className="vol-choice-sub">
              Tracing:{" "}
              <span style={{ color: getStepStatusColor(sw.traced) }}>
                {getStepStatus(sw.traced)}
              </span>{" "}
              {sw.traced > 0  ? `(${sw.trace_volunteer_name})` : ""}
            </div>}
            {step === "carving" && <div className="vol-choice-sub">
              Carving:{" "}
              <span style={{ color: getStepStatusColor(sw.carved) }}>
                {getStepStatus(sw.carved)}
              </span>{" "}
              {sw.carved > 0  ? `(${sw.carve_volunteer_name})` : ""}
            </div>}
          </button>
        ))}
      </div>
      <p className="vol-foot">Choose the one that matches your pumpkin or has your name.</p>
    </>
  );
};

export default Options;